import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import moment from "moment";
import StudentCard from "../common/studentCardv2";
import MutipleInterviewStudentCardDialog from "../common/mutipleInterviewStudentCardDialog";
import StudentDetailsDialog from "../common/studentDetailsDialog_v2";
import {
	getStudentDetails,
	resetStudentToShowDetails,
} from "../../../../actions/thirdYearStudentActions";
import { callStudentBatchForInterview } from "../../../../actions/companyActions";
import { getCompanyAccountType } from "../../../../reducers/companySelector";
import {
	RestrictedCompanyAccountType,
	InterviewBatchStatus,
} from "../../../../utils/constants";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";
import StepNotification from "./stepNotification";
import {
	Row,
	Col,
	Button,
	Modal,
	Empty,
	Steps,
	Divider,
	Checkbox,
	Space,
	Tooltip,
} from "antd";
import { RightOutlined } from "@ant-design/icons";
import { ReturnBackIcon } from "../../../common/icons";
import DateAndTimeSlotPicker from "../common/dateAndTimeSlotPicker";
import ScheduledInterviewSlots from "../common/scheduledInterviewSlots";
import GalkButton from "../../../common/component/button";
import {
	prepareTimeslotStructure,
	prepareTimeslotStructurewithDateTimeStamp,
	prepareBookedTimeslotStructure,
	prepareBookedTimeslotStructureWithDateTimeObject,
	prepareBookedTimeslotStructureWithDateTimeObjectFromAdmin,
	getAcceptedInterviewSlot,
	getAcceptedInterviewSlotFromAdmin,
	timeSlotModel,
	createTimeSlotsWithDateTimeObject,
	selectionSteps,
	getStudentDataAddedWithProjectPreference,
} from "./helper";
import "./taggedStudentsForInternship.css";

const Step = Steps.Step;

const SearchResult = ({
	studentList,
	getStudentDetails,
	resetStudentToShowDetails,
	callStudentBatchForInterview,
	ifActionInProgress,
	studentDetails,
	isLoading,
	companyAccountType,
	currentInterviewBatch,
	studentsSelectedForInterview,
	interviewLink,
	taggedStudentData,
	finalTimeSlotArrangedByAdmin,
}) => {
	const [showStudentDetails, setShowStudentDetails] = useState(false);
	const [currentStep, setCurrentStep] = useState(0);
	const [selectedStudents, setSelectedStudents] = useState([]);
	const [timeSlot, setTimeSlot] = useState({ ...timeSlotModel });
	const [finalInterviewSchedule, setFinalInterviewSchedule] = useState([]);
	const [makeTimeSlotReadonly, setMakeTimeSlotReadonly] = useState(false);
	const [studentSelectionEnabled, setStudentSelectionEnabled] = useState(false);
	const [notifyFinalTimeslot, setnotifyFinalTimeslot] = useState(false);
	const [showMultipleInterviewModal, setShowMultipleInterviewModal] =
		useState(false);
	const [studentToSetMultipleInterview, setStudentToSetMultipleInterview] =
		useState(false);
	const { t } = useTranslation();

	useEffect(() => {
		if (currentInterviewBatch && currentInterviewBatch.current) {
			const selectedStudentList = currentInterviewBatch.studentsList;
			if (studentList && studentList.length > 0) {
				const selectedStudentProfile = studentList.filter(
					(x) =>
						selectedStudentList.findIndex((stu) => x.id === stu.studentId) >= 0
				);

				setSelectedStudents(selectedStudentProfile);
			}
			setStudentSelectionEnabled(false);

			if (
				currentInterviewBatch.status === InterviewBatchStatus.InterviewSlotGiven
			) {
				setMakeTimeSlotReadonly(true);
				setCurrentStep(2);

				const timeSlot = prepareTimeslotStructurewithDateTimeStamp(
					currentInterviewBatch.slotsProposedByCompany
				);

				setTimeSlot({ ...timeSlot });
			}
			if (
				studentsSelectedForInterview &&
				studentsSelectedForInterview.length > 0
			) {
				let allApproved = true;
				studentsSelectedForInterview.forEach((x) => {
					if (!x.interviewTimeApproved) allApproved = false;
				});

				if (allApproved) {
					setStudentSelectionEnabled(false);
					setCurrentStep(3);
					setnotifyFinalTimeslot(true);

					// setFinalInterviewSchedule(
					// 	prepareBookedTimeslotStructureWithDateTimeObjectFromAdmin(
					// 		studentsSelectedForInterview.map((stu, i) => ({
					// 			bookedBy: stu.studentId,
					// 			date: stu.interviewStartTime,
					// 			startTime: stu.interviewStartTime,
					// 			endTime: stu.interviewEndTime,
					// 		}))
					// 	)
					// );

					setFinalInterviewSchedule(
						prepareBookedTimeslotStructureWithDateTimeObjectFromAdmin(
							finalTimeSlotArrangedByAdmin.map((time, i) => ({
								date: time.startTime,
								startTime: time.startTime,
								endTime: time.endTime,
							}))
						)
					);
				}
			}
			// if (
			// 	currentInterviewBatch.status ===
			// 		InterviewBatchStatus.InterviewSlotBooked ||
			// 	currentInterviewBatch.status === InterviewBatchStatus.InterviewComplete
			// ) {
			// 	setStudentSelectionEnabled(false);
			// 	setCurrentStep(3);

			// 	setFinalInterviewSchedule(
			// 		prepareBookedTimeslotStructureWithDateTimeObject(
			// 			currentInterviewBatch.slotsProposedByAdmin || []
			// 		)
			// 	);
			// }
		}
	}, [
		currentInterviewBatch,
		studentList,
		studentsSelectedForInterview,
		finalTimeSlotArrangedByAdmin,
	]);

	const showStudentDetailsHandler = (studentId) => {
		setShowStudentDetails(true);
		getStudentDetails(studentId);
	};

	const closeStudentDetailsHandler = () => {
		setShowStudentDetails(false);
		resetStudentToShowDetails();
	};

	const onStudentSelect = (e, studentId) => {
		let _selectedStudents = [...new Set(selectedStudents)];
		const checked = e.target.checked;

		if (checked) {
			_selectedStudents.push({
				...studentList.find((stu) => stu.id === studentId),
				noOfInterviewRequested: 1,
			});
		} else {
			_selectedStudents = _selectedStudents.filter(
				(stu) => stu.id !== studentId
			);
		}

		setSelectedStudents(_selectedStudents);
	};

	const onSelectStudentStepButtonClick = () => {
		setStudentSelectionEnabled(true);
	};

	const onSelectStudentStepCancelButtonClick = () => {
		setStudentSelectionEnabled(false);
	};

	const onRequestInterviewStepButtonClick = () => {
		setCurrentStep(2);
		setMakeTimeSlotReadonly(true);

		const availableTimeslots = createTimeSlotsWithDateTimeObject(timeSlot);

		let interviewBatch = {
			current: true,
			studentsList: getStudentDataAddedWithProjectPreference(
				selectedStudents,
				taggedStudentData
			),
			slotsProposedByCompany: availableTimeslots,
			// availableTimeslotsMeta: timeSlot,
			createdDate: moment().format("LL"),
			closedDate: "",
			notifiedStudents: false,
			notifiedCompany: false,
			scheduleComplete: false,
			status: InterviewBatchStatus.InterviewSlotGiven,
			timeslotAckByCompany: false,
			timeslotAckByStudent: false,
		};

		const studentsNotCalledForInterview = studentList.filter(
			(x) => selectedStudents.findIndex((stu) => x.id === stu.id) < 0
		);
		callStudentBatchForInterview(interviewBatch, studentsNotCalledForInterview);
		// console.log("TIME SLOT:", interviewBatch);
	};

	const onRequestInterviewStepBackButtonClick = () => {
		setCurrentStep(0);
		setStudentSelectionEnabled(true);
		setSelectedStudents([]);
	};

	const onSetTimeSlotButtonClick = () => {
		setCurrentStep(1);
		setStudentSelectionEnabled(false);
	};

	const timeSlotHandlers = {
		onChangeDate1: (date, dateString) => {
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date1: {
						date,
						dateString,
					},
				};
			});
		},
		onChangeDate1Time1Start: (time, timeString) => {
			let startTime = new moment(time);
			const endTime = startTime.add(1, "h");
			const endTimeString = endTime.format("h:mm A");

			setTimeSlot((prevState) => {
				return {
					...prevState,
					date1time1: {
						startTime: time,
						startTimeString: timeString,
						endTime,
						endTimeString,
					},
				};
			});
		},
		onChangeDate1Time1End: (time, timeString) => {
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date1time1: {
						...prevState.date1time1,
						endTime: time,
						endTimeString: timeString,
					},
				};
			});
		},
		onChangeDate1Time2Start: (time, timeString) => {
			let startTime = new moment(time);
			const endTime = startTime.add(1, "h");
			const endTimeString = endTime.format("h:mm A");
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date1time2: {
						startTime: time,
						startTimeString: timeString,
						endTime,
						endTimeString,
					},
				};
			});
		},
		onChangeDate1Time2End: (time, timeString) => {
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date1time2: {
						...prevState.date1time2,
						endTime: time,
						endTimeString: timeString,
					},
				};
			});
		},
		onChangeDate1Time3Start: (time, timeString) => {
			let startTime = new moment(time);
			const endTime = startTime.add(1, "h");
			const endTimeString = endTime.format("h:mm A");
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date1time3: {
						startTime: time,
						startTimeString: timeString,
						endTime,
						endTimeString,
					},
				};
			});
		},
		onChangeDate1Time3End: (time, timeString) => {
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date1time3: {
						...prevState.date1time3,
						endTime: time,
						endTimeString: timeString,
					},
				};
			});
		},
		onChangeDate2: (date, dateString) => {
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date2: {
						date,
						dateString,
					},
				};
			});
		},
		onChangeDate2Time1Start: (time, timeString) => {
			let startTime = new moment(time);
			const endTime = startTime.add(1, "h");
			const endTimeString = endTime.format("h:mm A");
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date2time1: {
						startTime: time,
						startTimeString: timeString,
						endTime,
						endTimeString,
					},
				};
			});
		},
		onChangeDate2Time1End: (time, timeString) => {
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date2time1: {
						...prevState.date2time1,
						endTime: time,
						endTimeString: timeString,
					},
				};
			});
		},
		onChangeDate2Time2Start: (time, timeString) => {
			let startTime = new moment(time);
			const endTime = startTime.add(1, "h");
			const endTimeString = endTime.format("h:mm A");
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date2time2: {
						startTime: time,
						startTimeString: timeString,
						endTime,
						endTimeString,
					},
				};
			});
		},
		onChangeDate2Time2End: (time, timeString) => {
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date2time2: {
						...prevState.date2time2,
						endTime: time,
						endTimeString: timeString,
					},
				};
			});
		},
		onChangeDate2Time3Start: (time, timeString) => {
			let startTime = new moment(time);
			const endTime = startTime.add(1, "h");
			const endTimeString = endTime.format("h:mm A");
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date2time3: {
						startTime: time,
						startTimeString: timeString,
						endTime,
						endTimeString,
					},
				};
			});
		},
		onChangeDate2Time3End: (time, timeString) => {
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date2time3: {
						...prevState.date2time3,
						endTime: time,
						endTimeString: timeString,
					},
				};
			});
		},
		onChangeDate3: (date, dateString) => {
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date3: {
						date,
						dateString,
					},
				};
			});
		},
		onChangeDate3Time1Start: (time, timeString) => {
			let startTime = new moment(time);
			const endTime = startTime.add(1, "h");
			const endTimeString = endTime.format("h:mm A");
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date3time1: {
						startTime: time,
						startTimeString: timeString,
						endTime,
						endTimeString,
					},
				};
			});
		},
		onChangeDate3Time1End: (time, timeString) => {
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date3time1: {
						...prevState.date3time1,
						endTime: time,
						endTimeString: timeString,
					},
				};
			});
		},
		onChangeDate3Time2Start: (time, timeString) => {
			let startTime = new moment(time);
			const endTime = startTime.add(1, "h");
			const endTimeString = endTime.format("h:mm A");
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date3time2: {
						startTime: time,
						startTimeString: timeString,
						endTime,
						endTimeString,
					},
				};
			});
		},
		onChangeDate3Time2End: (time, timeString) => {
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date3time2: {
						...prevState.date3time2,
						endTime: time,
						endTimeString: timeString,
					},
				};
			});
		},
		onChangeDate3Time3Start: (time, timeString) => {
			let startTime = new moment(time);
			const endTime = startTime.add(1, "h");
			const endTimeString = endTime.format("h:mm A");
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date3time3: {
						startTime: time,
						startTimeString: timeString,
						endTime,
						endTimeString,
					},
				};
			});
		},
		onChangeDate3Time3End: (time, timeString) => {
			setTimeSlot((prevState) => {
				return {
					...prevState,
					date3time3: {
						...prevState.date3time3,
						endTime: time,
						endTimeString: timeString,
					},
				};
			});
		},
	};

	const ifTimeSlotValid = () => {
		if (!timeSlot.date1.date) return true;
		// if (!timeSlot.date2.date) return true;
		// if (!timeSlot.date3.date) return true;
		if (!timeSlot.date1time1.startTime) return true;
		// if (!timeSlot.date2time1.startTime) return true;
		// if (!timeSlot.date3time1.startTime) return true;

		return false;
	};

	const ifEligibleForMultipleInterview = (studentId) => {
		const found = selectedStudents.findIndex((stu) => stu.id === studentId);
		return found >= 0 ? false : true;
	};

	const getInterviewRequestCount = (studentId) => {
		const selectedStudentList = selectedStudents;
		const found = selectedStudentList.find((x) => x.id === studentId);
		if (!found) return <span></span>;
		if (found.noOfInterviewRequested > 1) {
			return (
				<div className="b2">
					<span>{`x ${found.noOfInterviewRequested} times`}</span>
				</div>
			);
		} else {
			return <span></span>;
		}
	};

	const setSelectedStudentForMultipleInterview = (studentId) => {
		const selectedStudentList = selectedStudents;
		const found = selectedStudentList.find((x) => x.id === studentId);

		setStudentToSetMultipleInterview(found);
	};

	const changeInterviewCount = (studentId, count) => {
		const updatedList = selectedStudents.map((stu) => {
			if (stu.id === studentId) {
				stu.noOfInterviewRequested = count;
			}
			return stu;
		});

		setSelectedStudents(updatedList);
	};

	return (
		<div className="internship_selectStudents_pageContainer">
			<div className="pageHeader_row">
				<div className="selectStudent_container_card_title_container">
					<div className="selectStudent_container_card_title_primary">
						{t("internship_selectStudent_pageTitle_primary")}
					</div>
					<div className="selectStudent_container_card_title-_econdary">
						<span>{t("internship_selectStudent_pageTitle_secondary")}</span>
					</div>
				</div>
			</div>
			<div className="taggedStudents_stepContainer">
				<Steps
					size="small"
					current={currentStep}
					direction="horizontal"
					labelPlacement="vertical"
				>
					{selectionSteps.map(({ description }, i) => (
						<Step key={i} description={t(description)} />
					))}
				</Steps>
			</div>
			{currentStep !== 3 && (
				<div className="taggedStudents_stepNotificationContainer">
					<StepNotification currentStep={currentStep} />
				</div>
			)}

			<div className="taggedStudents_stepActionContainer">
				{currentStep === 0 && !studentSelectionEnabled && (
					<div className="justifyContent_end">
						<GalkButton
							type="primary"
							width={180}
							onClick={onSelectStudentStepButtonClick}
						>
							{t("internship_selectStudent_actionButton_selectStudents")}
							<RightOutlined />
						</GalkButton>
					</div>
				)}
				{currentStep === 0 && studentSelectionEnabled && (
					<div className="justifyContent_spaceBetween">
						<GalkButton
							type="default"
							width={90}
							onClick={onSelectStudentStepCancelButtonClick}
						>
							<ReturnBackIcon width={18} height={18} />
							{t(
								"internship_selectStudent_actionButton_requestInterviewCancel"
							)}
						</GalkButton>
						<GalkButton
							type="primary"
							width={180}
							onClick={onSetTimeSlotButtonClick}
							disabled={selectedStudents.length === 0}
						>
							{t("internship_selectStudent_actionButton_setTimeSlot")}
							<RightOutlined />
						</GalkButton>
					</div>
				)}
				{currentStep === 1 && (
					<div className="justifyContent_spaceBetween">
						<GalkButton
							onClick={onRequestInterviewStepBackButtonClick}
							width={90}
						>
							<ReturnBackIcon width={18} height={18} />
							{t(
								"internship_selectStudent_actionButton_requestInterviewCancel"
							)}
						</GalkButton>
						<GalkButton
							type="primary"
							width={180}
							onClick={onRequestInterviewStepButtonClick}
							loading={ifActionInProgress}
							disabled={ifTimeSlotValid()}
						>
							{t("internship_selectStudent_actionButton_requestInterview")}
							<RightOutlined />
						</GalkButton>
					</div>
				)}
			</div>
			{(currentStep === 1 || currentStep === 2) && (
				<div className="taggedStudents_timeSlotContainer">
					<DateAndTimeSlotPicker
						timeSlot={timeSlot}
						handlers={timeSlotHandlers}
						readOnly={makeTimeSlotReadonly}
					/>
				</div>
			)}
			{currentStep === 3 && (
				<div className="taggedStudents_timeSlotContainer">
					<ScheduledInterviewSlots
						slotData={finalInterviewSchedule}
						interviewLink={interviewLink}
						heading={true}
					/>
				</div>
			)}
			{currentStep === 3 && notifyFinalTimeslot && (
				<Modal
					title={null}
					centered
					visible={true}
					onOk={() => {
						setnotifyFinalTimeslot(false);
					}}
					onCancel={() => {
						setnotifyFinalTimeslot(false);
					}}
					closable={false}
					footer={null}
					width={627}
				>
					<Row justify="center" gutter={8}>
						<div className="timeslot_decided_modal_header">
							{t(
								"internship_selectStudent_step4_interviewConfirmed_confirmPopup_heading"
							)}
						</div>
						<ScheduledInterviewSlots
							slotData={finalInterviewSchedule}
							heading={false}
						/>
					</Row>
					<Divider />
					<Row justify="center" gutter={20}>
						<GalkButton
							type="primary"
							width={180}
							onClick={() => {
								setnotifyFinalTimeslot(false);
							}}
						>
							OK
						</GalkButton>
					</Row>
				</Modal>
			)}
			<Row
				style={{
					justifyContent: "space-start",
					width: "100%",
					overflowY: "scroll",
					height: "-webkit-fill-available",
				}}
			>
				{currentStep === 0 && studentList.length < 1 && (
					<Col
						span={24}
						style={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
						}}
					>
						<Empty />
					</Col>
				)}
				{currentStep === 0 && studentSelectionEnabled && (
					<Divider>
						{`${selectedStudents.length} ${t(
							"internship_selectStudent_divider_numberOfStudentSelected"
						)}`}{" "}
					</Divider>
				)}
				{currentStep === 0 &&
					studentList.map((student, i) => (
						<Col key={i}>
							<StudentCard
								student={student}
								onClick={showStudentDetailsHandler}
							>
								{studentSelectionEnabled && (
									<>
										<Checkbox
											onChange={(e) => onStudentSelect(e, student.id)}
										></Checkbox>
										{getInterviewRequestCount(student.id)}
										<div className="row1_action">
											<Tooltip
												color={"#475467"}
												title={t("tooltip_button_multipleInterview")}
											>
												<Button
													size="small"
													ghost
													disabled={ifEligibleForMultipleInterview(student.id)}
													onClick={(e) => {
														e.stopPropagation();
														setShowMultipleInterviewModal(true);
														setSelectedStudentForMultipleInterview(student.id);
													}}
												>
													+ Add
												</Button>
											</Tooltip>
										</div>
									</>
								)}
							</StudentCard>
						</Col>
					))}

				{currentStep > 0 && (
					<>
						{currentStep === 3 ? (
							<Divider>{`${t(
								"internship_selectStudent_step4_divider_numberOfStudentSelected"
							)}`}</Divider>
						) : (
							<Divider>
								{`${selectedStudents.length} ${t(
									"internship_selectStudent_divider_numberOfStudentSelected"
								)}`}{" "}
							</Divider>
						)}
						{selectedStudents.map((student, i) => (
							<Col key={i}>
								<StudentCard
									student={student}
									onClick={showStudentDetailsHandler}
									// acceptedInterviewSlot={getAcceptedInterviewSlot(
									// 	currentInterviewBatch,
									// 	student.id
									// )}
									acceptedInterviewSlot={getAcceptedInterviewSlotFromAdmin(
										studentsSelectedForInterview,
										student.id
									)}
								>
									<>
										<span></span>
										{getInterviewRequestCount(student.id)}
										{currentStep < 2 ? (
											<div className="row1_action">
												<Tooltip
													color={"#475467"}
													title="If you want to conduct multiple interviews with this student, please select."
												>
													<Button
														size="small"
														ghost
														disabled={ifEligibleForMultipleInterview(
															student.id
														)}
														onClick={(e) => {
															e.stopPropagation();
															setShowMultipleInterviewModal(true);
															setSelectedStudentForMultipleInterview(
																student.id
															);
														}}
													>
														+ Add
													</Button>
												</Tooltip>
											</div>
										) : (
											<span></span>
										)}
									</>
								</StudentCard>
							</Col>
						))}
					</>
				)}
			</Row>
			{showStudentDetails && (
				<StudentDetailsDialog
					onCloseHandler={closeStudentDetailsHandler}
					studentDetails={studentDetails}
					isLoading={isLoading}
				/>
			)}
			{showMultipleInterviewModal && (
				<MutipleInterviewStudentCardDialog
					modalCloseHandler={() => {
						setShowMultipleInterviewModal(false);
						setStudentToSetMultipleInterview(null);
					}}
					student={studentToSetMultipleInterview || {}}
					interviewCountHandler={changeInterviewCount}
				/>
			)}
		</div>
	);
};

const mapStateToProps = (state) => ({
	ifActionInProgress: state.company.actionInProgress,
	studentDetails: state.thirdYearStudents.studentToShowDetails,
	isLoading: state.thirdYearStudents.studentToShowDetailsLoading,
	companyAccountType: getCompanyAccountType(state),
	currentInterviewBatch: state.company.company.interviewBatchForInternship,
	studentsSelectedForInterview:
		state.company.company.galkRecruitStudentsSelectedForInterview || [],
	interviewLink:
		state.company.company.galkRecruitInterviewLink ||
		"Interview link not available...",
	taggedStudentData:
		state.company.company.galkRecruitStudentsTaggedByWillings || [],
	finalTimeSlotArrangedByAdmin:
		state.company.company.galkRecruitInterviewSlot || [],
});

export default connect(mapStateToProps, {
	getStudentDetails,
	resetStudentToShowDetails,
	callStudentBatchForInterview,
})(withRouter(SearchResult));
